import { render, staticRenderFns } from "./CheckOutPageHistory.vue?vue&type=template&id=2bc07f19&scoped=true"
import script from "./CheckOutPageHistory.vue?vue&type=script&lang=js"
export * from "./CheckOutPageHistory.vue?vue&type=script&lang=js"
import style0 from "./CheckOutPageHistory.vue?vue&type=style&index=0&id=2bc07f19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc07f19",
  null
  
)

export default component.exports